import React from "react";
import ListComponent from "../components/ListComponent";

const List = () => {
  return (
    <div>
      <ListComponent />
    </div>
  );
};

export default List;
